import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import { Provider } from "react-redux";
import configureStore from "./store";
// import history from "./helpers/history";
// import { Router } from "react-router-dom";
// import { Router, Route, browserHistory } from "react-router";

import { ConnectedRouter } from "react-router-redux";
import createHistory from "history/createBrowserHistory";
import registerServiceWorker from "./registerServiceWorker";

const history = createHistory();
const store = configureStore(undefined, history);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js